export const iconFontAwesomeDesignVectorSquare = (
	<i className="fa-solid fa-vector-square"></i>
);
